import { detailResp, ExportReq, ExportResp, HttpService } from "@/core";
import {
  LeaseContractCount,
  LeaseContractInfo,
  LeaseContractPageReq,
  LeaseContractRecord,
  LeaseContractSimpleRecord,
  LeaseDetailImportResp,
} from "./lease-contract.interface";

export class LeaseContractService {
  static usePageApi() {
    const api = (params: LeaseContractPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/lease/contractOfTenancy/page",
        params,
      });
    return HttpService.usePagination<LeaseContractRecord>(api);
  }

  static useSimpList() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/lease/contractOfTenancy/page",
        params,
      });
    return HttpService.usePagination<LeaseContractSimpleRecord>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/lease/contractOfTenancy/${id}`,
      });
    return HttpService.useRequest<LeaseContractInfo>(api);
  }

  static useCreateApi() {
    const api = (data: any) =>
      HttpService.axios({
        method: "POST",
        url: "/lease/contractOfTenancy/add",
        data,
      });
    return HttpService.useRequest<detailResp>(api);
  }

  static useEditApi() {
    const api = (id: string, data: any) =>
      HttpService.axios({
        method: "POST",
        url: `/lease/contractOfTenancy/edit`,
        data,
      });
    return HttpService.useRequest<detailResp>(api);
  }

  static exportExcel() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: "/lease/contractOfTenancy/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static exportDetailExcel() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/lease/contractOfTenancy/detailFileExport/${id}`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static importExcel() {
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/lease/contractOfTenancy/detailFileImport?url=${url}`,
        // data: {
        //   url,
        // },
      });
    return HttpService.useRequest<LeaseDetailImportResp>(api);
  }

  static useContractCount() {
    const api = (id) =>
      HttpService.axios({
        method: "POST",
        url: `lease/leasePaymentApply/contractMoneyDetail/${id}`,
      });
    return HttpService.useRequest<LeaseContractCount>(api);
  }
}
